"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogChannel = void 0;
class ConsoleLogChannel {
    log(logEntry) {
        switch (logEntry.severity) {
            case "TRACE":
                console.trace(logEntry.message, logEntry);
                break;
            case "DEBUG":
                console.debug(logEntry.message, logEntry);
                break;
            case "INFO":
                console.info(logEntry.message, logEntry);
                break;
            case "WARN":
                console.warn(logEntry.message, logEntry);
                break;
            case "ERROR":
                console.error(logEntry.message, logEntry);
                break;
            case "FATAL":
                console.error(logEntry.message, logEntry);
                break;
            default:
                console.log(logEntry.message, logEntry);
        }
    }
}
exports.ConsoleLogChannel = ConsoleLogChannel;
